import React, { useEffect, useState } from "react";
import * as styles from "./splashScreen.css";
import logoImage from "../../../../assets/top/top_logo.png";

const SplashScreen: React.FC = () => {
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFading(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`${styles.container} ${isFading ? styles.fadeOutClass : ""}`}>
      <img src={logoImage} alt="Logo" className={styles.logo} />
    </div>
  );
};

export default SplashScreen;
